var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { format, parseISO } from "date-fns";
import { computed, ref, watch } from "vue";
import { fetcher } from "@/api/schema";
const jobsFetcher = fetcher.path("/api/jobs").method("get").create();
export function useMappingJobs(singleJobId, implicitCollectionJobsId) {
    const selectJobOptions = ref([]);
    const selectedJob = ref(undefined);
    const targetJobId = computed(() => {
        if (singleJobId.value) {
            return singleJobId.value;
        }
        else {
            return selectedJob.value;
        }
    });
    watch(implicitCollectionJobsId, () => __awaiter(this, void 0, void 0, function* () {
        if (implicitCollectionJobsId.value) {
            const response = yield jobsFetcher({ implicit_collection_jobs_id: implicitCollectionJobsId.value });
            const jobs = response.data;
            selectJobOptions.value = jobs.map((value, index) => {
                const isoCreateTime = parseISO(`${value.create_time}Z`);
                const prettyTime = format(isoCreateTime, "eeee MMM do H:mm:ss yyyy zz");
                return { value: value.id, text: `${index + 1}: ${prettyTime}` };
            });
            if (jobs[0]) {
                const job = jobs[0];
                selectedJob.value = job.id;
            }
        }
    }), { immediate: true });
    return { selectJobOptions, selectedJob, targetJobId };
}
